import React, { useEffect, useState } from "react";
import Loaders from "./Loaders";
import HeaderTop from "./HeaderTop";
import Menus from "./Menus";
import Footers from "./Footers";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { API_ROUTES } from "../../utils/constants";
import { format } from "date-fns";
import PieChart from "./PieChart";
import moment from "moment";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker";

const Index = (props) => {
  const { capitalizeWords, objectToFormData, isAuthExpired, errorFunction } =
    props;
  const [isFade, setIsFade] = useState(true);
  const [todayRevLoading, setTodayRevLoading] = useState(true);
  const [cpOptions, setCpOptions] = useState([]);
  const [serviceCounts, setServiceCounts] = useState(0);
  const [cpOptionsLoading, setCpOptionsLoading] = useState(false);
  const [subscribersCounts, setSubscribersCounts] = useState(0);
  const [unSubscribersCounts, setUnSubscribersCounts] = useState(0);
  const [syncCounts, setSyncCounts] = useState(0);
  const [unSyncCounts, setUnSyncCounts] = useState(0);
  const [serviveId, setServiveId] = useState("");
  const [networkId, setNetworkId] = useState("");
  const [subscribersList, setSubscribersList] = useState([]);
  const [revenueLastMonth, setRevenueLastMonth] = useState(0);
  const [revenueLoading, setRevenueLoading] = useState(false);
  const [revenueThisMonth, setRevenueThisMonth] = useState(0);
  const [revenue1Loading, setRevenue1Loading] = useState(false);
  const [allTotals, setAllTotal] = useState(0);

  const [percentThisMonth, setPercentThisMonth] = useState(0);
  const [percentLastMonth, setPercentLastMonth] = useState(0);

  const [todayRev, setTodayRev] = useState(0);
  const [syncs, setSyncs] = useState({
    Telco_Sync_Count: 0,
    Partner_Sync_Count: 0,
  });

  const {
    register: register1,
    reset: reset1,
    handleSubmit: handleSubmit1,
    formState: {
      errors: errors1,
      isSubmitting: isSubmitting1,
      isValid: isValid1,
    },
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    document.title = "Dashboard | Forthsoft";
  }, []);
  const userData = JSON.parse(localStorage.getItem("userDataFs"));

  const currentDate = new Date();
  const thisMonth = currentDate.toLocaleString("default", { month: "long" });

  const formatDate = (date, startDate = false) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const seconds = String(date.getSeconds()).padStart(2, "0");
    if (startDate) {
      return `${year}-${month}-${day} 00:00:00`;
    }
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const now = new Date();
  const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

  const [selectedDate, setSelectedDate] = useState(formatDate(now, true));
  const [selectedDate1, setSelectedDate1] = useState(formatDate(now));

  const handleStartDateChange = (date) => {
    setSelectedDate(formatDate(date));
  };

  const handleEndDateChange = (date) => {
    setSelectedDate1(formatDate(date));
  };

  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };
    Promise.all([
      //   loadScript('../assets/libs_/js/jquery.min.js'),
      loadScript("../assets/libs_/js/scripts2.js"),
    ])
      .then(() => {
        // Both scripts are loaded
      })
      .catch((error) => {
        console.error("Error loading scripts:", error);
      });
    return () => {
      // Remove the scripts here if necessary
    };
  }, []);

  const getDataCounts = async () => {

    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 30);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set time to midnight

    const chosen_start_date = selectedDate && selectedDate.replace(/-/g, "/");
    const chosen_end_date = selectedDate1 && selectedDate1.replace(/-/g, "/");

    const dataString = {
      service_id: serviveId,
      network_id: networkId,
      fro: chosen_start_date || today.toLocaleDateString("en-US") + " 00:00:00",
      to: chosen_end_date || today.toLocaleDateString("en-US") + " 23:59:59",
    };
    // console.log("dataString ===");
    // console.log(dataString);
    // return;

    setSubscribersCounts("Loading");
    setUnSubscribersCounts("Loading");
    setSyncCounts("Loading");
    setUnSyncCounts("Loading");

    try {


      const response = await fetch(API_ROUTES.ALL_COUNTS, {
        method: "POST",
        body: objectToFormData(dataString),
        headers: { token: userData?.responseDetails?.token },
      });
      const responseJSON = await response.json();

      if (responseJSON.status.toString() === "200") {
        // const responseData = responseJSON.data;
        setSubscribersCounts(responseJSON.data.subscribers);
        setUnSubscribersCounts(responseJSON.data.unsubscribers);
        setSyncCounts(responseJSON.data.chargingSync);
        setUnSyncCounts(responseJSON.data.chargingUnsync);
      }
    } catch (error) {
      console.log("Error getting subscriber count: ", error);
      // setSubscribersList([]);
      setIsFade(false);
    }
  };

  const get_today_rev = async () => {
    setTodayRevLoading(true);
    const data = {
      service_id: serviveId,
      network_id: networkId,
    };
    setTodayRev("Loading");
    try {
      const response = await fetch(API_ROUTES.TODAY_REVENUE, {
        method: "POST",
        body: objectToFormData(data),
        headers: { token: userData?.responseDetails?.token },
      });
      const responseJSON = await response.json();
      if (responseJSON.status.toString() === "200") {
        setTodayRevLoading(false);
        setTodayRev(responseJSON.data.totalRevenue);
      }
    } catch (error) {
      console.log("Error getting data: ", error);
      setTodayRevLoading(false);
    }
  };

  const getSyncs = async () => {
    const dataString = {
      network: "MTN",
    };
    try {
      const response = await fetch(API_ROUTES.SYNCS, {
        method: "POST",
        body: objectToFormData(dataString),
        headers: { token: userData?.responseDetails?.token },
      });
      const responseJSON = await response.json();
      if (responseJSON.status.toString() === "200") {
        setSyncs({
          Telco_Sync_Count: responseJSON.data.Telco_Sync_Count,
          Partner_Sync_Count: responseJSON.data.Partner_Sync_Count,
        });
      }
    } catch (error) {
      console.log("Error getting data: ", error);
      setIsFade(false);
    }
  };

  const user_id = localStorage.getItem("user_id");
  // console.log("datassss", user_id);

  const getServices = async () => {
    if (!networkId) {
      setCpOptions([]);
      setCpOptionsLoading(false);
      return;
    }

    const data = {
      service_id: user_id,
      network_id: networkId,
    };

    setCpOptions([]);
    setCpOptionsLoading(true);

    try {
      const response = await fetch(API_ROUTES.VIEW_SERVICES, {
        method: "POST",
        body: objectToFormData(data),
        headers: { token: userData?.responseDetails?.token },
      });
      const responseJSON = await response.json();

      isAuthExpired(responseJSON); // check for expired login

      // console.log("responseJSONdddd", responseJSON);

      if (responseJSON.status.toString() === "200") {
        const allServices = responseJSON.data;

        const uniqueServices = allServices.filter((service, index, self) =>
          index === self.findIndex(s => s.serviceId === service.serviceId)
        );

        setCpOptions(uniqueServices);
        setCpOptionsLoading(false);
      } else {
        setCpOptions([]);
        setCpOptionsLoading(true);
        if (responseJSON.status.toString() === "500") {
          Swal.fire({
            title: "Error",
            text: responseJSON.required_fields,
            icon: "error",
          });
          return;
        }
        Swal.fire({
          title: "Error",
          text: responseJSON.message,
          icon: "error",
        });
      }
    } catch (error) {
      if (error.response) {
        errorFunction(error);
        setCpOptions([]);
        setCpOptionsLoading(true);
      }
    }
  };

  useEffect(() => {
    getServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [networkId]);

  useEffect(() => {
    getDataCounts();
    get_today_rev();
  }, [serviveId, networkId, selectedDate, selectedDate1]);

  // console.log("selectedDatesss", selectedDate && selectedDate.replace(/-/g, "/"));
  // console.log("selectedDatesss1", selectedDate1 && selectedDate1.replace(/-/g, "/"));

  const getServiceCounts = async () => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 30);

    const chosen_start_date = selectedDate && selectedDate.replace(/-/g, "/");
    const chosen_end_date = selectedDate1 && selectedDate1.replace(/-/g, "/");

    const dataString = {
      service_id: serviveId,
      network_id: networkId,
      fro: chosen_start_date || startDate.toLocaleDateString("en-US"),
      to: chosen_end_date || endDate.toLocaleDateString("en-US"),
    };
    try {
      const response = await fetch(API_ROUTES.SERVICE_COUNTS, {
        method: "POST",
        body: objectToFormData(dataString),
        headers: { token: userData?.responseDetails?.token },
      });
      const responseJSON = await response.json();
      if (responseJSON.status.toString() === "200") {
        setServiceCounts(responseJSON.data);
      }
    } catch (error) {
      console.log("Error getting data: ", error);
      setServiceCounts(0);
    }
  };
  useEffect(() => {
    getServiceCounts();
  }, [serviveId, networkId, selectedDate, selectedDate1]); // newly added

  const getSubscribers = async () => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7); // 7 days
    endDate.setDate(endDate.getDate() + 1);

    const chosen_start_date = selectedDate && selectedDate.replace(/-/g, "/");
    const chosen_end_date = selectedDate1 && selectedDate1.replace(/-/g, "/");

    const dataString = {
      service_id: serviveId,
      network_id: networkId,
      token: userData?.responseDetails?.token,
      fro: chosen_start_date || startDate.toLocaleDateString("en-US"),
      to: chosen_end_date || endDate.toLocaleDateString("en-US"),
    };
    try {
      const response = await fetch(API_ROUTES.SUBSCRIBERS, {
        method: "POST",
        body: objectToFormData(dataString),
        headers: { token: userData?.responseDetails?.token },
      });
      const responseJSON = await response.json();
      isAuthExpired(responseJSON); // check for expired login

      if (responseJSON.status.toString() === "200") {
        const responseData = responseJSON.data;

        setSubscribersList(responseData.slice(0, 6));
        setIsFade(false);
      }
    } catch (error) {
      console.log("Error getting data: ", error);
      setSubscribersList([]);
      setIsFade(false);
    }
  };
  useEffect(() => {
    getSubscribers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [networkId]);

  useEffect(() => {
    const allTotal =
      parseFloat(revenueLastMonth) + parseFloat(revenueThisMonth);
    setAllTotal(allTotal);

    const lastMonthVal =
      parseFloat(parseFloat(revenueLastMonth) / parseFloat(allTotal)) * 100;
    const thisMonthVal =
      parseFloat(parseFloat(revenueThisMonth) / parseFloat(allTotal)) * 100;

    setPercentThisMonth(isNaN(thisMonthVal) ? 0 : thisMonthVal.toFixed(1));
    setPercentLastMonth(isNaN(lastMonthVal) ? 0 : lastMonthVal.toFixed(1));
  }, [revenueLastMonth, revenueThisMonth]);

  currentDate.setMonth(currentDate.getMonth() - 1);
  const lastMonth = currentDate.toLocaleString("default", { month: "long" });

  const handleActionChange = (event) => {
    const ids = event.target.value;
    setServiveId(ids);
  };

  const handleNetworkChange = (event) => {
    setNetworkId(event.target.value);
    setServiveId(""); // service list depends on network — clear any prior selection
  };

  return (
    <>
      <Loaders />

      <div className="flapt-page-wrapper mainContent">
        <Menus />

        <div className="flapt-page-content">
          <HeaderTop />

          <div className="main-content introduction-farm pl-15 pr-15 pl-xs-0 pr-xs-0">
            <div className="content-wraper-area">
              <div className="dashboard-area">
                <div className="container-fluid">
                  <div className="row g-4">
                    <div className="col-12 mb-15">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="dashboard-header-title">
                          <h2 className="mb-0 mt--5">Your Dashboard</h2>
                        </div>

                        {/* <div className="dashboard-infor-mation">
                                                    <div className="dashboard-btn-group d-flex align-items-center">
                                                        <a href="#" className="dash-btn ms-2"><i className="ti-settings"></i></a>
                                                        <a href="#" className="dash-btn ms-2"><i className="ti-plus"></i></a>
                                                    </div>
                                                </div> */}
                      </div>
                    </div>

                    <div className="mt--20 mt-md-0 row">
                      <div className="offset-xl-2 col-xl-3 offset-lg-1 col-lg-3 col-md-3 col-sm-4 pr-sm-0">
                        <select
                          onChange={handleActionChange}
                          className="filter_text"
                          value={serviveId}
                          disabled={!networkId}
                          aria-label="Filter by service"
                          // {...register1("cp_id", { required: "Service is required" })}
                          style={{
                            textTransform: "capitalize",
                            opacity:
                              !networkId
                                ? 0.4
                                : cpOptions.length !== 0 || !cpOptionsLoading
                                ? 1
                                : 0.4,
                          }}
                        >
                          <option value="">
                            {" "}
                            {!networkId
                              ? "-Select Network First-"
                              : cpOptions.length !== 0 || !cpOptionsLoading
                              ? `-Select Service- ${cpOptions.length > 0
                                ? "(" + cpOptions.length + ")"
                                : ""
                              }`
                              : "Loading"}
                          </option>
                          {cpOptions.length !== 0 ? (
                            cpOptions.map((opt, index) => (
                              <option
                                key={`${opt.serviceId}_${index}`}
                                value={opt.serviceId}
                              >
                                {opt.serviceName}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>
                              None
                            </option>
                          )}
                        </select>
                      </div>

                      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 pl-lg-5 pr-lg-0">
                        <select
                          onChange={handleNetworkChange}
                          className="filter_text"
                          value={networkId}
                          aria-label="Filter by network"
                        >
                          <option value="">-Network (All)-</option>
                          <option value="1">MTN</option>
                          <option value="2">GLO</option>
                          <option value="3">Airtel</option>
                          <option value="4">9Mobile</option>
                        </select>
                      </div>

                      <div className="col-xl-2 col-lg-2 col-md-3 col-sm-3 pl-lg-5 pr-lg-0 pl-sm-15">
                        <DatePicker
                          selected={selectedDate}
                          className="filter_text"
                          onChange={handleStartDateChange}
                          dateFormat="yyyy-MM-dd"
                          isClearable
                          placeholderText="Start Date"
                          calendarClassName="large-calendar"
                        />
                      </div>

                      <div className="col-xl-2 col-lg-2 col-md-3 col-sm-3 pl-lg-5 pr-lg-0">
                        <DatePicker
                          selected={selectedDate1}
                          className="filter_text"
                          onChange={handleEndDateChange}
                          dateFormat="yyyy-MM-dd"
                          isClearable
                          placeholderText="End Date"
                          calendarClassName="large-calendar"
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-lg-5 col-xxl-5">
                      <div className="card_height">
                        <div className="card profile-greeting p-0">
                          <div className="card-body text-center">
                            <div className="img-overlay">
                              <h1 className="mt--5_">
                                Hello,{" "}
                                {capitalizeWords(
                                  userData?.responseDetails?.name
                                )}
                              </h1>
                              <p
                                className="pt-10 mb-lg-50 mb-md-50 mb-xs-30"
                                style={{ opacity: "0.8" }}
                              >
                                Welcome to the Forthsoft Dashboard!{" "}
                                <span className="d-sm-block d-none">
                                  We are happy to have you visit our dashboard.
                                </span>
                              </p>

                              <div className="offset-lg-2 col-lg-8 offset-sm-2 col-sm-8">
                                <Link
                                  className="btn btn-block btn-primary btn-primaryi"
                                  to="/settings"
                                >
                                  My Settings
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-lg-3 col-xl-4 col-xxl-3 mt-md-30 mt-xs--10">
                      <div className="card card_height mt-sm-15 mt-xs--15">
                        <div className="card-body" data-intro="New Orders">
                          <div className="single-widget">
                            <div>
                              <div className="row wIcons">
                                <div className="col-md-4">
                                  <i className="bx bx-history"></i>
                                </div>
                                <div
                                  className="col-md-8 text-start"
                                  style={{ marginTop: "-10px" }}
                                >
                                  {/* <div style={{ position:'absolute', top:'6px' }}>{thisMonth}</div> */}
                                  <div
                                    style={{ position: "absolute", top: "6px" }}
                                  >
                                    Selected Date
                                  </div>
                                  <h3 className="mt-25">Statistics</h3>
                                </div>
                              </div>

                              <div className="mt-15 mb-xs-15">
                                <div className="row mb-10">
                                  <div className="col-8">Subscription</div>
                                  <div className="col-4 text-end colored">
                                    {subscribersCounts !== null
                                      ? subscribersCounts.toLocaleString()
                                      : 0}
                                  </div>
                                </div>
                                <div className="row mb-10">
                                  <div className="col-8">UnSubscription</div>
                                  <div className="col-4 text-end colored">
                                    {unSubscribersCounts !== null
                                      ? unSubscribersCounts.toLocaleString()
                                      : 0}
                                  </div>
                                </div>
                                <div className="row mb-10">
                                  <div className="col-8">Services</div>
                                  <div className="col-4 text-end colored">
                                    {serviceCounts !== null
                                      ? serviceCounts.toLocaleString()
                                      : 0}
                                  </div>
                                </div>

                                {/* <div className="row mb-10">
                                                                    <div className="col-8">Telco SYNC</div>
                                                                    <div className="col-4 text-end colored">{syncs.Telco_Sync_Count > 0 ? syncs.Telco_Sync_Count.toLocaleString() : <font style={{ color:'#888', fontSize: '13px', fontWeight:'400' }}>Loading...</font>}</div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-8">Partner SYNC</div>
                                                                    <div className="col-4 text-end colored">{syncs.Partner_Sync_Count > 0 ? syncs.Partner_Sync_Count.toLocaleString() : <font style={{ color:'#888', fontSize: '13px', fontWeight:'400' }}>Loading...</font>}</div>
                                                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-lg-4 col-xl-5 col-xxl-4 mt-md-30 mt-xs--10">
                      <div className="card card_height mt-sm-15 mt-xs--15">
                        <div className="card-body" data-intro="New Customers">
                          <div className="single-widget">
                            <div className="dashboard-dropdown">
                              <h3 className="mt-10">Analysis</h3>
                              <p>
                                Analysis between last month and current month of
                                the year
                              </p>

                              <div
                                className="row pl-5 mt-15"
                                style={{ fontSize: "15px" }}
                              >
                                <div className="col-5 pb-5">Selected Date</div>
                                <div className="col-7 pb-5">
                                  {todayRevLoading ? (
                                    <font
                                      style={{
                                        fontSize: "12px",
                                        color: "#666",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Loading data...
                                    </font>
                                  ) : (
                                    <>
                                      &#8358;
                                      {parseFloat(todayRev).toLocaleString()}
                                    </>
                                  )}
                                </div>

                                {/* <div className="col-4 pb-5">
                                                                    {thisMonth}
                                                                </div>
                                                                <div className="col-8 pb-5">
                                                                    {
                                                                        revenue1Loading ?
                                                                        <font style={{ fontSize:'13px', color:'#666', fontWeight:'500' }}>Loading data...</font>
                                                                        :
                                                                        <>
                                                                            &#8358;{parseFloat(revenueThisMonth).toLocaleString()}
                                                                            &nbsp; <font style={{ fontSize:'14px', color:'#666', fontWeight:'500' }}>({percentThisMonth}%)</font>
                                                                        </>
                                                                    }
                                                                </div>
                                                                
                                                                <div className="col-4 pb-5">
                                                                    {lastMonth}
                                                                </div>
                                                                <div className="col-8 pb-5">
                                                                    {
                                                                        revenueLoading ? 
                                                                        <font style={{ fontSize:'13px', color:'#666', fontWeight:'500' }}>Loading data...</font>
                                                                        :
                                                                        <>
                                                                            ₦{parseFloat(revenueLastMonth).toLocaleString()}
                                                                            &nbsp;
                                                                            <font style={{ fontSize:'14px', color:'#666', fontWeight:'500' }}>({percentLastMonth}%)</font>
                                                                        </>
                                                                    }
                                                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-10 mt-sm-5 mt-xs-0">
                    <div className="col-lg-12 col-md-12 mb-20 mb-sm-10">
                      <div className="card">
                        <div className="card-body pt-5">
                          <div className="card-title border-bootom-none mb-10 d-flex align-items-center justify-content-between">
                            <h6 className="mb-0">Last 6 Subscribers</h6>
                            <div className="dashboard-dropdown table_dropdown">
                              <div className="dropdown">
                                <button
                                  className="btn btn_dots dropdown-toggle_"
                                  type="button"
                                  id="dashboardDropdown57"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <i className="ti-more-alt"></i>
                                </button>

                                <div
                                  className="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="dashboardDropdown57"
                                >
                                  <Link
                                    className="dropdown-item"
                                    to="/subscribers"
                                  >
                                    <i className="ti-eye"></i>View All
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="table-responsive text-nowrap">
                            <table
                              className="table table-centered table-nowrap table-hover mb-0"
                              style={{ opacity: isFade ? "0.4" : 1 }}
                            >
                              <thead>
                                <tr>
                                  <th>Sender</th>
                                  <th>Receiver</th>
                                  <th>Message</th>
                                  <th>Service Name</th>
                                  <th>Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {subscribersList.length !== 0 &&
                                  subscribersList.map((subscriber) => {
                                    let subPhone = subscriber.senderAddress;

                                    if (subPhone.length >= 13) {
                                      const countryCode = subPhone.slice(0, 3);
                                      const restOfNumber = subPhone.slice(3);
                                      subPhone = `${countryCode}-${restOfNumber}`;
                                    }
                                    return (
                                      <tr key={subscriber.id}>
                                        <td>{subPhone}</td>
                                        <td>{subscriber.receiverAddress}</td>
                                        <td>{subscriber.message}</td>
                                        <td>
                                          {capitalizeWords(
                                            subscriber.serviceName
                                          )}
                                        </td>
                                        <td>
                                          {subscriber.created_at
                                            ? format(
                                              new Date(subscriber.created_at),
                                              "MMM d, yyyy h:mma"
                                            )
                                            : "Not Specified"}
                                        </td>
                                      </tr>
                                    );
                                  })}

                                {subscribersList.length === 0 && (
                                  <tr style={{ textAlign: "center" }}>
                                    <td
                                      style={{ fontSize: "17px" }}
                                      colSpan="5"
                                      className="pt-20 pb-20"
                                    >
                                      No subscribers found for the last 7 days
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-lg-4 mb-20">
                                            <div className="card mt-xs--15">
                                                <div className="card-body pt-5">
                                                    <div className="card-title mb-30 d-flex align-items-center justify-content-between">
                                                        <h6 className="mb-0">Analysis</h6>
                                                        <div className="dashboard-dropdown">
                                                            <div className="dropdown">
                                                                <button className="btn btn_dots dropdown-toggle_" type="button" id="dashboardDropdown60" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="ti-more-alt"></i></button>

                                                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dashboardDropdown57">
                                                                    <Link className="dropdown-item" to="/"><i className="ti-eye"></i>View All</Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="chart-area">
                                                        <div id="pie-chart"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                  </div>
                </div>
              </div>
            </div>

            <Footers />
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
